<script>
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import { tweened } from "svelte/motion"
  import Footer from "../components/Footer.svelte"
  import Header from "../components/Header.svelte"
  import ResultadoPersona from "../components/persona/Resultado_persona.svelte"
  import SinInformacion from "../components/Sin_informacion.svelte"
  import Spinner from "../components/Spinner.svelte"
  import { verifySession } from "../services/verifySession"
  import { BASE_URL } from "../stores/BASE_URL"
  import { user } from "../stores/User"
  import Sidebar from "../components/Sidebar.svelte"
  import Container from "../components/Container.svelte"

  let documento = ""
  let nombres = ""
  let paterno = ""
  let materno = ""
  let numero = ""
  let correo = ""

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    } else {
      verifySession($user.session_key)
      getPuntos()
      if (!$user.permisos.includes("persona")) {
        user.setUser(null)
        navigate("/", { replace: true })
      }

      //Pass
      if ($user.actualizar_clave == "1") {
        navigate("/seguridad", { replace: true })
      }

      //C
      if ($user.verificar == "1") {
        navigate("/verificar", { replace: true })
      }
    }
  })

  let data = {
    personas: undefined,
    loading: false,
  }

  const buscarPersona = async () => {
    await verifySession($user.session_key)
    if (!validarFormulario()) {
      alert("Completar campos")
      return
    }
    reiniciarTiempo()
    let session_key = $user.session_key
    let url = `${BASE_URL}persona.php?documento=${documento}&paterno=${paterno}&materno=${materno}&nombres=${nombres}&numero=${numero}&correo=${correo}&session_key=${session_key}`
    data.loading = true
    const response = await fetch(url)
    const resp = await response.json()
    data = {
      personas: resp.data,
      loading: false,
    }
  }

  const validarFormulario = () => {
    let validation = false

    documento = documento.trim()
    nombres = nombres.trim()
    paterno = paterno.trim()
    materno = materno.trim()
    numero = numero.trim()
    correo = correo.trim()

    if (documento.length > 5) validation = true
    if (numero.length > 5) validation = true
    if (nombres != "" && paterno != "" && materno != "") validation = true
    // Si es un correo válido validar con expresión regular
    if (correo != "") {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (re.test(correo.toLowerCase())) {
        validation = true
      }
    }

    return validation
  }

  const limpiar = () => {
    documento = ""
    nombres = ""
    paterno = ""
    materno = ""
    numero = ""
    correo = ""
    data = {
      personas: undefined,
      loading: false,
    }
  }

  let bloquados = {
    documento: false,
    nombres: false,
    paterno: false,
    materno: false,
    numero: false,
    correo: false,
  }

  $: if (documento != "") {
    bloquados = {
      documento: false,
      nombres: true,
      paterno: true,
      materno: true,
      numero: true,
      correo: true,
    }
  } else {
    bloquados = {
      documento: false,
      nombres: false,
      paterno: false,
      materno: false,
      numero: false,
      correo: false,
    }
  }

  $: if (nombres != "" || paterno != "" || materno != "") {
    bloquados = {
      documento: true,
      nombres: false,
      paterno: false,
      materno: false,
      numero: true,
      correo: true,
    }
  } else {
    bloquados = {
      documento: false,
      nombres: false,
      paterno: false,
      materno: false,
      numero: false,
      correo: false,
    }
  }

  $: if (numero != "") {
    bloquados = {
      documento: true,
      nombres: true,
      paterno: true,
      materno: true,
      numero: false,
      correo: true,
    }
  } else {
    bloquados = {
      documento: false,
      nombres: false,
      paterno: false,
      materno: false,
      numero: false,
      correo: false,
    }
  }

  $: if (correo != "") {
    bloquados = {
      documento: true,
      nombres: true,
      paterno: true,
      materno: true,
      numero: true,
      correo: false,
    }
  } else {
    bloquados = {
      documento: false,
      nombres: false,
      paterno: false,
      materno: false,
      numero: false,
      correo: false,
    }
  }

  const getPuntos = async () => {
    const response = await fetch(
      `${BASE_URL}session.php?session_key=${$user.session_key}`,
    )
    const resp = await response.json()

    if (resp.status === "success") {
      let temp_user = $user
      temp_user.consumo = resp.data.consumo
      temp_user.consultas = resp.data.consultas
      temp_user.inicio = resp.data.inicio
      temp_user.fin = resp.data.fin
      user.setUser(temp_user)
    } else {
      navigate("/", { replace: true })
    }
  }

  // Tiempo de sessión
  let original = 20 * 60
  let timer = tweened(original)

  setInterval(() => {
    if ($timer > 0) $timer--
  }, 1000)

  $: minutes = Math.floor($timer / 60)

  $: if (minutes <= 0) {
    user.setUser(null)
    navigate("/", { replace: true })
  }

  const reiniciarTiempo = () => {
    timer = tweened(original)
  }
</script>

{#if $user}
  <main class="d-flex flex-column md:flex-row min-vh-100">
    <Sidebar />

    <div class="d-flex flex-column flex-grow-1 page-content">
      <Header />

      <div class="container-fluid bg-2 flex-grow-1 py-5">
        <div class="row">
          <div class="col-12 xl:col-9 2xl:col-7">
            <Container>
              <h4 class="mb-3">
                <i
                  class="bi bi-person-vcard fg-secondary me-1"
                  aria-hidden="true"
                ></i>
                Búsqueda de Personas
              </h4>
              <form on:submit|preventDefault={buscarPersona} class="row g-3">
                <div class="col-12 sm:col-6 lg:col-4">
                  <label
                    for="inputDocumento"
                    class="form-label small fg-secondary">Documento</label
                  >
                  <input
                    type="text"
                    id="inputDocumento"
                    class="form-control form-control-sm"
                    bind:value={documento}
                    disabled={bloquados.documento}
                    placeholder="Ingrese el documento"
                  />
                </div>

                <div class="col-12 sm:col-6 lg:col-4">
                  <label for="inputNombres" class="form-label fg-secondary"
                    >Nombres</label
                  >
                  <input
                    type="text"
                    id="inputNombres"
                    class="form-control form-control-sm"
                    bind:value={nombres}
                    disabled={bloquados.nombres}
                    placeholder="Ingrese los nombres"
                  />
                </div>

                <div class="col-12 sm:col-6 lg:col-4">
                  <label
                    for="inputApellidoPaterno"
                    class="form-label small fg-secondary"
                    >Apellido Paterno</label
                  >
                  <input
                    type="text"
                    id="inputApellidoPaterno"
                    class="form-control form-control-sm"
                    bind:value={paterno}
                    disabled={bloquados.paterno}
                    placeholder="Ingrese el apellido paterno"
                  />
                </div>

                <div class="col-12 sm:col-6 lg:col-4">
                  <label
                    for="inputApellidoMaterno"
                    class="form-label small fg-secondary"
                    >Apellido Materno</label
                  >
                  <input
                    type="text"
                    id="inputApellidoMaterno"
                    class="form-control form-control-sm"
                    bind:value={materno}
                    disabled={bloquados.materno}
                    placeholder="Ingrese el apellido materno"
                  />
                </div>

                <div class="col-12 sm:col-6 lg:col-4">
                  <label for="inputNumero" class="form-label small fg-secondary"
                    >Número Telefónico</label
                  >
                  <input
                    type="text"
                    id="inputNumero"
                    class="form-control form-control-sm"
                    bind:value={numero}
                    disabled={bloquados.numero}
                    placeholder="Ingrese el número telefónico"
                  />
                </div>

                <div class="col-12 sm:col-6 lg:col-4">
                  <label for="inputCorreo" class="form-label small fg-secondary"
                    >Correo Electrónico</label
                  >
                  <input
                    type="text"
                    id="inputCorreo"
                    class="form-control form-control-sm"
                    bind:value={correo}
                    disabled={bloquados.correo}
                    placeholder="Ingrese el correo electrónico"
                  />
                </div>

                <div class="col-12 d-flex gap-3 my-5 justify-content-end">
                  <button
                    type="button"
                    class="btn btn-solid theme-neutral btn-sm"
                    on:click={limpiar}
                    ><i class="bi bi-eraser-fill"></i> Limpiar
                  </button>
                  {#if data.loading}
                    <button
                      type="submit"
                      class="btn btn-solid theme-primary btn-sm disabled"
                    >
                      <i class="bi bi-search"></i> Buscando...
                    </button>
                  {:else}
                    <button
                      type="submit"
                      class="btn btn-solid theme-primary btn-sm"
                    >
                      <i class="bi bi-search"></i> Buscar
                    </button>
                  {/if}
                </div>
              </form>
            </Container>

            <div class="mt-5">
              {#if data.loading === true}
                <Spinner message="Buscando" />
              {:else if data.personas !== undefined}
                <Container>
                  <h5 class="mb-3">
                    <i class="bi bi-card-list fg-secondary me-1"></i>
                    Resultados de la búsqueda
                  </h5>
                  {#if data.personas.error_id === undefined}
                    <ResultadoPersona personas={data.personas} />
                  {:else if data.personas.message == "No tiene consultas disponibles"}
                    <SinInformacion message={data.personas.message} />
                  {:else}
                    <SinInformacion />
                  {/if}
                </Container>
              {/if}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </main>
{/if}
